import React from 'react';

export const pageMeta = {
  "name": "HTML DOM Objects",
  "link": "/javascript/references/html-dom-objects"
};

export default function JavascriptReferencesHtmlDomObjects() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">HTML DOM Objects</h2>
      <p>Route: /javascript/references/html-dom-objects</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
